import { useQuery } from '@apollo/client';
import { GET_IMAGES_QUERY } from './constants';
import { separateImages, shouldSkip } from './helpers';

const useLongformGallery = ({
  imageIds = [],
  priorityLimit = 0,
  caption = '',
  shouldDisplayCaption = false,
  enableLightbox = false,
  toggleModal = () => {},
  handleSelectedImage = () => {}
}) => {
  const skip = shouldSkip(imageIds);

  const { data, loading, error } = useQuery(GET_IMAGES_QUERY, {
    variables: { where: { id: { _in: imageIds } } },
    skip
  });

  const { getImages } = data || {};

  const groupedImages = separateImages(getImages, priorityLimit, shouldDisplayCaption);

  const handleImageOnClick = clickedImageId => {
    if (!enableLightbox) return;
    toggleModal();
    handleSelectedImage(clickedImageId);
  };

  return {
    loading,
    error,
    shouldDisplayCaption,
    caption,
    groupedImages,
    handleImageOnClick
  };
};

export default useLongformGallery;
